$(function () {

  $('#event_color').spectrum({
    allowEmpty: true, 
    preferredFormat: 'rgb', 
    cancelText: I18n.t('cancel'), 
    chooseText: I18n.t('save'), 
    showButtons: true, 
    showInput: true, 
    color: $('#event_color').val(),
    showPalette: true,
    palette: [
      ["#600","#783f04","#7f6000","#274e13","#0c343d","#073763","#20124d","#4c1130"],
      ["#900","#b45f06","#bf9000","#38761d","#134f5c","#0b5394","#351c75","#741b47"],
      ["#c00","#e69138","#f1c232","#6aa84f","#45818e","#3d85c6","#674ea7","#a64d79"],
      ["#e06666","#f6b26b","#ffd966","#93c47d","#76a5af","#6fa8dc","#8e7cc3","#c27ba0"],
      ["#ea9999","#f9cb9c","#ffe599","#b6d7a8","#a2c4c9","#9fc5e8","#b4a7d6","#d5a6bd"],
      ["#f4cccc","#fce5cd","#fff2cc","#d9ead3","#d0e0e3","#cfe2f3","#d9d2e9","#ead1dc"]
    ]
  }); 

  function timeToggle () {
    var $timeFormGroups = $('.start-time-form-group, .end-time-form-group');

    if ($('#event_all_day').is(':checked')) {
      $timeFormGroups.hide();
    } else {
      $timeFormGroups.show();
    }    
  }

  $('#event_all_day').on('change', function () {
    timeToggle();
  }).trigger('change');

});